module.exports = __webpack_public_path__ + "static/media/mblBGlogosignup.354e966b.svg";